import { NewPaymentButton } from '@components/NewPaymentButton';
import { PageContainer } from '@components/PageContainer';
import { PermissionGate } from '@components/PermissionGate';
import { TemplatesList } from '@components/TemplatesList';
import { useBankProfile } from '@contexts/BankProfileContext';
import { PlusIcon, TransferIcon } from '@gurupay/gp-ui-library';
import {
	BatchTransactions,
	CreatedTransactions,
	LatestTransactions,
} from '@pages/payments/components';
import { useTranslation } from 'react-i18next';
import { Capability } from 'types/roles';

export const PaymentsPage = () => {
	const { t } = useTranslation('', { keyPrefix: 'paymentsPage' });
	const { hasCapability } = useBankProfile();

	return (
		<PageContainer icon={<TransferIcon />} title={t('title')}>
			<div className="space-y-10">
				<PermissionGate capability={Capability.CREATE_PAYMENT}>
					<NewPaymentButton icon={<PlusIcon />} openDirection="bottom">
						{t('newPayment')}
					</NewPaymentButton>
				</PermissionGate>
				<PermissionGate capability={Capability.SIGN_PAYMENT}>
					<CreatedTransactions />
				</PermissionGate>
				{/*ToDo: https://gurupay.atlassian.net/browse/CS-738 */}
				{/*<ScheduledTransactions />*/}
				<LatestTransactions />
				<BatchTransactions />
				<TemplatesList
					params={{ per_page: 5 }}
					showButton={hasCapability(Capability.CREATE_PAYMENT)}
					title={t('templates')}
				/>
			</div>
		</PageContainer>
	);
};

PaymentsPage.displayName = 'PaymentsPage';
